import httpService from './httpService';
import config from '../config.json';
function getIdeas() {
  return httpService.get(config.apiEndpoint + 'ideas');
}
function getIdeaVotes(ideaId) {
  return httpService.get(config.apiEndpoint + 'ideas/' + ideaId + '/votes');
}
export async function createIdea(idea) {
  const result = await httpService.post(config.apiEndpoint + 'ideas', idea);
  return result.data;
}
export async function updateIdea(idea) {
  const result = await httpService.put(
    config.apiEndpoint + 'ideas/' + idea.id,
    idea
  );
  return result.data;
}
export async function getIdea(ideaId) {
  const result = await httpService.get(config.apiEndpoint + 'ideas/' + ideaId);
  return result.data.idea;
}
export async function voteIdea(idea) {
  const result = await httpService.post(
    config.apiEndpoint + 'ideas/' + idea.id + '/vote'
  );
  return result.data;
}
export async function deleteIdea(ideaId) {
  const result = await httpService.delete(
    config.apiEndpoint + 'ideas/' + ideaId
  );
  return result.data;
}
export default {
  getIdeas,
  createIdea,
  voteIdea,
  deleteIdea,
  updateIdea,
  getIdea,
  getIdeaVotes
};
